import { useProduct } from '@/entities/product';
import { useAutoshipCustomerStatus } from '@/features/autoship-customer-status';
import { useFrequencyCalculatorDrawerStore } from '@/features/frequency-calculator-drawer/model';
import { SelectFrequency } from '@/features/select-frequency';

export const FrequencyOptions = () => {
    const { product } = useProduct();
    const { isExistingAutoshipCustomer } = useAutoshipCustomerStatus();
    const appliedFrequency = useFrequencyCalculatorDrawerStore(state => state.appliedFrequency);

    // Show "One Time" option only for:
    // - Existing autoship customers (logged in with active subscription, not soft login)
    // - Not pharmacy products
    const shouldShowOneTime = isExistingAutoshipCustomer && !product?.pharmacy;
    const mostCommonValue =
        appliedFrequency?.source === 'fallback'
            ? `${appliedFrequency.autoshipFrequency}_${appliedFrequency.autoshipUnit}`
            : undefined;

    return <SelectFrequency withOneTime={shouldShowOneTime} mostCommonValue={mostCommonValue} />;
};
